







import { Component, Vue } from 'vue-property-decorator';
import { SysConst as SC } from '@/trials/plugins/const';
import { sessionModule } from '@/trials/store/modules/session';

@Component
export default class PredictResultMenu extends Vue {
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // アクティブコンテンツ
    private get currentContent() {
        return sessionModule.getCurrentRouterViewPredictResult;
    }

    private get enabledPredictPhase(): boolean {
        return sessionModule.getEnabledPredictPhase;
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        // Child コンポーネントの指定なし
        if (this.$route.path == SC.Path.PREDICT_RESULT_MENU) {
            // Child コンポーネントへのルーティング
            this.$router.replace(this.currentContent);
        }
    }
}
